import type { JobSearchAssistPills } from 'src/graphql/graphql';

export const mockedJobSearchAssistPills: JobSearchAssistPills = {
  __typename: 'JobSearchAssistPills',
  data: [
    {
      isActive: false,
      keywords: 'software developer',
      label: 'Software Developer',
      stateToken: 'token-software-developer',
    },
    {
      isActive: false,
      keywords: 'software engineer',
      label: 'Software Engineer',
      stateToken: 'token-software-engineer',
    },
    {
      isActive: false,
      keywords: 'frontend developer',
      label: 'Frontend Developer',
      stateToken: 'token-frontend-developer',
    },
    {
      isActive: false,
      keywords: 'backend developer',
      label: 'Backend Developer',
      stateToken: 'token-backend-developer',
    },
    {
      isActive: false,
      keywords: 'full stack developer',
      label: 'Full Stack Developer',
      stateToken: 'token-full-stack-developer',
    },
    {
      isActive: false,
      keywords: 'web developer',
      label: 'Web Developer',
      stateToken: 'token-web-developer',
    },
    {
      isActive: false,
      keywords: 'mobile developer',
      label: 'Mobile Developer',
      stateToken: 'token-mobile-developer',
    },
    {
      isActive: false,
      keywords: 'data scientist',
      label: 'Data Scientist',
      stateToken: 'token-data-scientist',
    },
  ],
  token: 'jobsearch-assist-token-123456',
};

export const mockedJobSearchAssist = {
  __typename: 'JobSearchAssist',
  pills: mockedJobSearchAssistPills,
};
